/*global DSV, jQuery */

/** 
 * DSV formsDynamics
 */

(function ($, window) {
    "use strict";

    DSV.ui.formsDynamics = {
        validateCheckboxLists: function(container) {
            //timeout is needed for dynamics form script to update error attributes before handling this custom validation.
            setTimeout(function(){
                const checkboxLists = container.find('[data-editorblocktype="Field-checkboxList"]');
                const validationError = container.find('[data-editorblocktype="Field-checkboxList"] .lp-form-fieldInput[aria-labelledby]');

                //if dynamic form error is present a custom class is added to checkboxlist container
                if (validationError.length > 0) {
                    checkboxLists.addClass("checkboxList-error");
                } else {
                    checkboxLists.removeClass("checkboxList-error");
                }
            }, 100);
        },

        init: function(container) {
            container.on('click', 'button[type="submit"]', function(){
                DSV.ui.formsDynamics.validateCheckboxLists(container);
            });

            container.on('change', '[data-editorblocktype="Field-checkboxList"] .lp-form-fieldInput', function(){
                DSV.ui.formsDynamics.validateCheckboxLists(container);
            });
        }
    };

})(jQuery, window);